import React, { useState } from 'react'

import { message, Checkbox } from 'antd'

import { observer } from 'mobx-react-lite'

import { useVendorStores } from 'vendor/hooks/use-stores'
import { ManagedVendorUser } from 'vendor/server/vendor_settings/manage_users'

type UserTogglePublicProps = {
  isPublic?: boolean
  userId: string
  userName: string
} & ManagedVendorUser

export const UserTogglePublic = observer<UserTogglePublicProps>(
  ({ userId, isPublic = false, userName = '', is_active }) => {
    const { vendorSettingStore } = useVendorStores()

    const [isSubmitting, setSubmitting] = useState(false)

    const handleChange = async (event) => {
      setSubmitting(true)
      const checked = event.target.checked
      try {
        await vendorSettingStore.updateUser(userId, { is_public: checked })
        message.success(`Changed ${userName} to ${checked ? 'public' : 'private'}`)
      } catch (err) {
        message.error(`Unable to change ${userName} to ${checked ? 'public' : 'private'}`)
      } finally {
        setSubmitting(false)
      }
    }

    return <Checkbox onChange={handleChange} checked={isPublic} disabled={isSubmitting || !is_active} />
  },
)
